import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { GetPromptTemplatesResponse } from "@/types/agenticAI";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getPromptTemplates = async (
  topic: string
): Promise<GetPromptTemplatesResponse> => {
  try {
    const { data } = await axiosInstance.get("/v1/prompt-templates", {
      params: { topic }
    });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);

    const newError = new CustomError(message, status);
    throw newError;
  }
};
